import { render, staticRenderFns } from "./SlidesUploads.vue?vue&type=template&id=2695752c"
import script from "./SlidesUploads.vue?vue&type=script&lang=js"
export * from "./SlidesUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports